import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { baseApi } from '@Services/baseApi.service';
import { rtkQueryErrorLogger } from '@Utils/middlewares/globalErrorHandler.middleware';

import rootReducer from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rtkQueryErrorLogger, baseApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store/reducer itself
// Inferring these types from the store/reducer itself means that they correctly update as you add more state slices or modify middleware settings.

setupListeners(store.dispatch);
export default store;

export type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];
